module.exports = __webpack_public_path__ + "img/logo-white.81de3faa.jpg";